/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Account_SettingsInputs */

const nl_account_account_settings = /** @type {(inputs: Account_Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accountinstellingen`)
};

/**

* @param {Account_Account_SettingsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const account_account_settings = /** @type {((inputs?: Account_Account_SettingsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Account_SettingsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_account_account_settings(inputs)
});
export { account_account_settings as "account.account_settings" }